import { roleIdByName } from "src/app/auth/constants/auth.constants";
import {
  IArea,
  ICountry,
  IOrganization,
  IRegion,
  ISede,
  ISubArea,
} from "src/app/catalog/interfaces/catalog.interface";

export class User implements IOrganizationInfo {
  id!: number;
  name!: string;
  email!: string;
  createdDate!: Date;
  permisions!: string[];
  celular!: string;
  alias!: string;
  homeLocation!: string;
  personNumber!: string;
  personNumberHeadDevelopment?: string;
  isHeadDevelopment!: boolean;
  headDevelopment?: IUsersHeadDev;
  fkIdRol!: number;
  numberPersonNationalLeader!: string;
  status!: number;
  token!: string; //previously type Session -> was on the archetype -> not used
  constructor(data?: Partial<User>) {
    if (data) {
      Object.assign(this, data);
    }
  }
  fkIdSede!: number;
  fkIdRegion!: number;
  fkIdFunctionalArea!: number;
  fkIdSubarea!: number;
  fkIdOrganization!: number;
  fkIdCountry!: number;
}
export interface IPonenteSel {
  id: number;
  name: string;
  personalNumber: number;
  apellidoPaterno?: string;
  apellidoMaterno?: string;
}

export interface IOrganizationInfo {
  fkIdSede: number;
  fkIdRegion: number;
  fkIdFunctionalArea: number;
  fkIdSubarea: number;
  fkIdOrganization: number;
  fkIdCountry: number;
}

export interface IOrganizationInfoPopulated {
  sede?: ISede;
  region?: IRegion;
  functionalArea?: IArea;
  subarea?: ISubArea;
  organization?: IOrganization;
  country?: ICountry;
}

export interface IUsersHeadDev extends IOrganizationInfo {
  id: number;
  name: string;
  email: string;
  personNumber: string;
  numberPersonNationalLeader: string;
}

export interface IUser extends IOrganizationInfo {
  id?: number;
  name: string;
  email: string;
  createdDate: Date;
  personNumber: string;
  status?: number;
  homeLocation: string;
  personNumberHeadDevelopment?: string;
  isHeadDevelopment: boolean;
  numberPersonNationalLeader: string;
  fkIdRol: roleIdByName;
  headDevelopment?: IUsersHeadDev;
}

export interface IPonentes {
  id?: number;
  name: string;
  personNumber: string;
  homeLocation: string;
}
